import { CampaignJoinInfoDto } from 'src/types/generated';
import BaseReadApiModule from 'src/api/baseRead';

class CampaignApi extends BaseReadApiModule<CampaignJoinInfoDto> {
  protected baseRoute = '/campaigns';
}

export default CampaignApi;
